import request from '@/api/request';

const defaultRequest = request('https://api.motrak.vn/client/v2');
const devRequest = request('https://binhlh-gw.vietmap.vn/motrak-dev');

export function getLanguages (params) {
  return defaultRequest({
    url: '/api/v1/languages-by-json',
    method: 'get',
    params
  });
}

export function getLanguagesForMobile () {
  return defaultRequest({
    url: '/api/v1/mobile/languages',
    method: 'get',
  });
}

export function updateLanguage (data) {
  return defaultRequest({
    url: '/api/v1/language/updatetranslations',
    method: 'post',
    data
  });
}

export function getLanguageByKey (params) {
  return defaultRequest({
    url: '/api/v1/language-by-key',
    method: 'get',
    params
  });
}

export function updateLanguageDev (data) {
  return devRequest({
    url: '/api/v1/language/updatetranslations',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/language.js